module.exports = __webpack_public_path__ + "img/5Y.8856f62b.png";